import { UseFormRegister, FieldValues, UseFormSetValue } from 'react-hook-form'
import { MEDIATEKA_DOWNLOAD } from '@/constants/urls'
import { IAnswer, IOneOfMany } from '@/models'
import { useWindowSize } from '@/hooks/useWindowSize'
import { Emoji, Input, Text } from '@/components/ui'
import { SelectAnswer } from '../ui'
import s from './question-types.module.scss'
import { EXPIRED_ANSWER_TITLE } from '@/constants/quiz'

interface IOneOfManyQuestionProps {
  question: IOneOfMany
  register: UseFormRegister<FieldValues>
  setValue: UseFormSetValue<FieldValues>
}

const OneOfManyQuestion = ({ question, register, setValue }: IOneOfManyQuestionProps) => {
  const { deviceWidth } = useWindowSize()

  return (
    <>
      {question.answers
        .filter((q) => EXPIRED_ANSWER_TITLE !== q.title)
        .map((answer: IAnswer) => (
          <SelectAnswer
            key={answer.uuid}
            name={`${question.id}.answer_uuid`}
            register={register}
            value={answer.uuid}
            type='radio'
            onChange={(e) => {
              e.preventDefault()
              setValue(`${question.id}.answer_uuid`, answer.uuid)
            }}
          >
            {answer?.title && <Text>{answer?.title}</Text>}
            {answer?.image_id && (
              <img
                src={`${MEDIATEKA_DOWNLOAD}/${answer.image_id}`}
                className={s['answer-image']}
                alt='Изображение ответа'
              />
            )}
            {answer?.smile && (
              <Emoji name={answer.smile} size={deviceWidth === 'large' ? 'lg' : 'md'} style={{ marginLeft: 3 }} />
            )}
          </SelectAnswer>
        ))}
      {question.free_form_answer_available && (
        <SelectAnswer
          name={`${question.id}.answer_uuid`}
          register={register}
          value='FREE_FORM'
          type='radio'
          onChange={(e) => {
            e.preventDefault()
            setValue(`${question.id}.answer_uuid`, 'FREE_FORM')
          }}
        >
          <Input
            name={`${question.id}.free_form_answer`}
            register={register}
            className={s['free-form-answer-input']}
            placeholder='Введите свой вариант ответа (Не более 500 символов)'
            fluid
          />
        </SelectAnswer>
      )}
    </>
  )
}

export default OneOfManyQuestion
